export default "__VITE_ASSET__BjectUQe__"